import { Route, Routes } from "react-router-dom";
import QuizDetailRoute from "./QuizDetail/quiz-detail";

const CourseQuizzesRoute = () => {
  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <Routes>
          <Route path=":id" element={<QuizDetailRoute />} />
        </Routes>
      </div>
    </div>
  );
};

export default CourseQuizzesRoute;
